var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspenso({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.067 7.81697L13.8839 13L19.067 18.183L18.183 19.067L13 13.8839L7.81697 19.067L6.93303 18.183L12.1161 13L6.93303 7.81697L7.81697 6.93303L13 12.1161L18.183 6.93303L19.067 7.81697ZM25.5 13C25.5 19.8925 19.8925 25.5 13 25.5C6.10745 25.5 0.5 19.8925 0.5 13C0.5 6.10745 6.10745 0.5 13 0.5C19.8925 0.5 25.5 6.10745 25.5 13ZM24.25 13C24.25 6.79669 19.2033 1.75 13 1.75C6.79669 1.75 1.75 6.79669 1.75 13C1.75 19.2033 6.79669 24.25 13 24.25C19.2033 24.25 24.25 19.2033 24.25 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspenso);
export default __webpack_public_path__ + "static/media/suspenso.5ab3492bdf3a083d161e33a0218b2515.svg";
export { ForwardRef as ReactComponent };